import axios from "./api.request";
import { LoadingBar } from "iview";
import $ from "jquery";

export default {
  get(api = "", params = {}) {
    LoadingBar.start();
    return new Promise((resolve, reject) => {
      axios
        .request({
          url: api,
          params,
          method: "get"
        })
        .then(function(response) {
          LoadingBar.finish();
          resolve(response.data);
        })
        .catch(function(error) {
          LoadingBar.finish();
          console.log(error);
          reject(error);
        });
    });
  },
  post(api = "", params = {}) {
    LoadingBar.start();
    return new Promise((resolve, reject) => {
      axios
        .request({
          url: api,
          data: params,
          method: "post"
        })
        .then(function(response) {
          LoadingBar.finish();
          resolve(response.data);
        })
        .catch(function(error) {
          LoadingBar.finish();
          console.log(error);
          reject(error);
        });
    });
  },
  upload(baseUrl = "", api = "", params = {}, timeout = 1000000) {
    LoadingBar.start();
    return new Promise((resolve, reject) => {
      let formData = new FormData();
      formData.append("userid", params.userid);
      formData.append("jobtype", params.jobtype);
      formData.append("upload", params.upload);
      $.ajax({
        data: formData,
        url: `https://${baseUrl}${api}`,
        processData: false,
        contentType: false,
        mimeType: "multipart/form-data",
        dataType: "json",
        type: "POST",
        timeout,
        success: result => {
          LoadingBar.finish();
          resolve(result);
        },
        error: res => {
          LoadingBar.finish();
          console.log(res);
          reject(res);
        }
      });
    });
  }
};
